import * as React from "react";
type Props = {
  className?: string,
};
function SvgPersonFilled({ className }: Props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="utility-person-filled"
      className={className}
    >
      <g clipPath="url(#clip0_1978_16831)">
        <path
          d="M15.88 14.01C16.8959 13.2369 17.6451 12.1658 18.023 10.9464C18.4009 9.72691 18.3886 8.4199 17.9879 7.20776C17.5871 5.99562 16.8179 4.93885 15.7877 4.18494C14.7574 3.43102 13.5174 3.0176 12.2409 3.00236C10.9643 2.98712 9.71481 3.37083 8.66683 4.09994C7.61884 4.82905 6.82465 5.86716 6.3951 7.06939C5.96554 8.27161 5.92207 9.57796 6.27073 10.8061C6.6194 12.0342 7.34281 13.1228 8.34 13.92C5.2 15.1 3 17.77 3 20.86C3 21.1252 3.10536 21.3796 3.29289 21.5671C3.48043 21.7546 3.73478 21.86 4 21.86H20C20.2652 21.86 20.5196 21.7546 20.7071 21.5671C20.8946 21.3796 21 21.1252 21 20.86C20.9311 19.3367 20.4062 17.8692 19.4932 16.6478C18.5803 15.4264 17.3215 14.5074 15.88 14.01Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_1978_16831">
          <rect
            width={18}
            height={18.86}
            fill="white"
            transform="translate(3 3)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
export default SvgPersonFilled;
